export default class MotionDetector {
    constructor() {
        this.previous = null
        this.width = 0
        this.height = 0
    }

    reset() {
        this.previous = null
    }

    analyse(frame, width, height, config, region) {
        const size = width * height
        const grey = new Uint8Array(size)
        const data = frame.data
        for (let i = 0, p = 0; p < size; p++, i += 4) {
            grey[p] = (data[i] * 77 + data[i + 1] * 151 + data[i + 2] * 28) >> 8
        }

        if (!this.previous || this.width !== width || this.height !== height) {
            this.previous = grey
            this.width = width
            this.height = height
            return { level: 0, center: null, box: null }
        }

        const x0 = Math.max(0, Math.floor((region?.x ?? 0) * width))
        const y0 = Math.max(0, Math.floor((region?.y ?? 0) * height))
        const x1 = Math.min(width, Math.ceil(((region?.x ?? 0) + (region?.w ?? 1)) * width))
        const y1 = Math.min(height, Math.ceil(((region?.y ?? 0) + (region?.h ?? 1)) * height))

        let hits = 0
        let sumX = 0
        let sumY = 0
        let minX = width
        let minY = height
        let maxX = 0
        let maxY = 0
        const threshold = config.pixelThreshold

        for (let y = y0; y < y1; y++) {
            const row = y * width
            for (let x = x0; x < x1; x++) {
                const p = row + x
                const diff = Math.abs(grey[p] - this.previous[p])
                if (diff > threshold) {
                    hits++
                    sumX += x
                    sumY += y
                    if (x < minX) minX = x
                    if (y < minY) minY = y
                    if (x > maxX) maxX = x
                    if (y > maxY) maxY = y
                }
            }
        }

        this.previous = grey
        const area = Math.max(1, (x1 - x0) * (y1 - y0))
        const level = (hits / area) * 100

        if (hits === 0) return { level: 0, center: null, box: null }

        return {
            level,
            center: { x: sumX / hits / width, y: sumY / hits / height },
            box: {
                x: minX / width,
                y: minY / height,
                w: (maxX - minX) / width,
                h: (maxY - minY) / height,
            },
        }
    }
}
